// react
import { useContext } from 'react';

// types
import { ActionButton } from '../../../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// router
import { useSearchParams } from 'react-router-dom';

// context
import { ContextIfr } from '../../Project.context';

// mui
import { Grid, Typography, TypographyProps } from '@mui/material';

// cards
import { CardKeyValue } from '../../../../cards/CardKeyValue/CardKeyValue';

// ui
import { Currency } from '../../../../ui/Currency/Currency';
import { Time } from '../../../../ui/Time/Time';
import { UserAvatarModified } from '../../../../ui/UserAvatarModified/UserAvatarModified';

// icons
import { ModeEditOutlined as IconModeEdit } from '@mui/icons-material';

export const Details = () => {
	// hooks
	const { ifr } = useContext(ContextIfr);
	const [searchParams, setSearchParams] = useSearchParams();
	const { t } = useTranslation();

	// vars
	const TypographyProps: TypographyProps = {
		color: 'black',
		variant: 'body1',
		fontWeight: 600,
	};

	const actionsPeriod: ActionButton[] = [];

	if (ifr?.status === 'DRAFT') {
		actionsPeriod.push({
			children: <IconModeEdit />,
			onClick: () => {
				searchParams.set('dialog', 'editIfr');
				searchParams.set('dialogIfr', String(ifr?.id));
				setSearchParams(searchParams);
			},
			size: 'small',
			sx: {
				padding: 0,
			},
			variant: 'text',
		});
	}

	return (
		<Grid container spacing={2}>
			<Grid item xs={12} lg={true}>
				<CardKeyValue
					actions={actionsPeriod}
					label={{ children: t('period') }}
					value={{
						children: (
							<Typography component="span" {...TypographyProps}>
								<Time date={ifr?.dateStart} TypographyProps={TypographyProps} />
								{' - '}
								<Time date={ifr?.dateEnd} TypographyProps={TypographyProps} />
							</Typography>
						),
					}}
				/>
			</Grid>
			<Grid item xs={6} lg={true}>
				<CardKeyValue
					label={{ children: t('currency') }}
					value={<Currency currency={ifr?.currency || ''} />}
				/>
			</Grid>
			<Grid item xs={6} lg={true}>
				<CardKeyValue
					label={{ children: t('finalized') }}
					value={{
						children: (
							<UserAvatarModified
								ifr={ifr || undefined}
								variant="compact"
								activityTypes={['IFR_FINALIZED']}
							/>
						),
						color: 'brand.grey.500',
					}}
				/>
			</Grid>
			<Grid item xs={6} lg={true}>
				<CardKeyValue
					label={{ children: t('created') }}
					value={{
						children: (
							<UserAvatarModified
								ifr={ifr || undefined}
								variant="compact"
								activityTypes={['IFR_CREATED']}
							/>
						),
						color: 'brand.grey.500',
					}}
				/>
			</Grid>
			<Grid item xs={6} lg={true}>
				<CardKeyValue
					label={{ children: t('modified') }}
					value={{
						children: (
							<UserAvatarModified
								ifr={ifr || undefined}
								variant="compact"
								activityTypes={['IFR_UPDATED']}
							/>
						),
						color: 'brand.grey.500',
					}}
				/>
			</Grid>
		</Grid>
	);
};
